<template>
  <b-card-code
    no-body
  >
    <b-row
      class="px-2 mb-2"
    >
      <b-col
        v-if="$can('create', 'subnets')"
        order-md="2"
        order="1"
        class="text-right d-flex align-items-end justify-content-end"
      >
        <div class="d-flex justify-content-end align-items-center mr-2">
          <div
            v-if="(searchFields && searchFields.length > 0) || (orderBy && orderBy.length > 0) || (sortedBy && sortedBy.length > 0)"
            class="d-flex justify-content-end align-items-center mr-2"
          >
            <b-button
              variant="primary"
              class="reset-filters-button"
              @click="resetFilter"
            >
              <feather-icon
                icon="XIcon"
                size="12"
                stroke="#f0554e"
                class="text-body align-middle mr-25"
              />
              Reset filters
            </b-button>
          </div>
          <b-button
            to="/ipam/ipv4/create"
            variant="primary"
            class="mr-2"
          >
            Create
          </b-button>
          <b-button
            v-if="$can('additional-action-delete', 'subnets')"
            variant="primary"
            class="mr-2"
            @click="toggleFilterOnlyTrashed"
          >
            <span v-if="this.onlyTrashed">Without deleted</span>
            <span v-else>Only deleted</span>
          </b-button>
          <div
            v-if="$can('delete', 'subnets')"
            label-class="label-class"
            class="with-deleted-checkbox d-flex flex-direction-column"
          >
            <span>With deleted</span>
            <b-form-checkbox
              class="mr-0"
              switch
              inline
              @change="setFilterWithTrashed"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <table-mobile
      :items="items"
      :fields="fields"
      :pagination="{
        pagination: pagination,
        perPage: perPage,
        currentPage: page,
        pageSizeOptions: pageSizeOptions,
        enabled: true,
        perPageChanged: perPageChanged,
        changePage: changePage,
      }"
      :actions="[{
        icon: 'Edit2Icon',
        label: 'Edit',
        click: (id) => toEdit(id),
        can: $can('update', 'subnets'),
        visible: () => $can('update', 'subnets'),
        type: 'secondary',
      }, {
        icon: 'TrashIcon',
        label: 'Delete',
        click: (id) => deleteHandler(id),
        can: $can('delete', 'subnets'),
        visible: (item) => !item.is_deleted,
        type: 'danger',
      },{
        icon: 'TrashIcon',
        label: 'Permanently delete',
        click: (id) => deleteHandler(id),
        can: $can('delete', 'subnets'),
        visible: (item) => item.is_deleted,
        type: 'danger',
      },{
        icon: 'RefreshCcwIcon',
        label: 'Recover',
        click: (id) => recoverRow(id),
        can: $can('delete', 'subnets'),
        visible: (item) => item.is_deleted,
        type: 'secondary',
      }]"
    />
    <b-card-body class="no-padding-table">
      <!-- table -->
      <vue-good-table
        ref="VueGoodTable"
        compact-mode
        :is-loading="isLoading"
        :columns="fields"
        :rows="items"
        :total-rows="pagination.total"
        class="subnet-table hide-mobile-table"
        :row-style-class="rowStyleClassFn"
        mode="remote"
        :group-options="{
          enabled: windowWidth > 576,
        }"
        :sort-options="{
          enabled: true,
          multipleColumns: true,
          initialSortBy: {field: orderBy, type: sortedBy}
        }"
        :pagination-options="{
          enabled: true,
          perPage: perPage,
          setCurrentPage: page
        }"
        @on-sort-change="onSortChange"
        @on-column-filter="columnFilterFn"
      >
        <template slot="loadingContent">
          <b-spinner
            variant="primary"
            label="Spinning"
          />
        </template>
        <template
          slot="table-header-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="$can('update', 'subnets')"
                  @click.prevent="toEdit(props.row.id)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="deleteHandler(props.row.id)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="deleteHandler(props.row.id)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Permanently delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="recoverRow(props.row.id)"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    class="mr-50"
                  />
                  <span>Recover</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <span v-else-if="props.column.field === 'is_public'">
            <b-badge
              v-if="props.row.is_public"
              pill
              variant="success"
            >True</b-badge>
            <b-badge
              v-else
              pill
              variant="danger"
            >False</b-badge>
          </span>
          <span v-else-if="props.column.field === 'ip_used'">
            <b-progress
              v-b-tooltip.hover
              style="min-width:90px; width:100%"
              :value="props.row.ip_used"
              :max="props.formattedRow.ip_total"
              animated
              :title="props.row.ip_used + ' of ' + props.formattedRow.ip_total"
            />
          </span>
        </template>
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  @click.prevent="getIPv4Address(props.row.id, props.row.name)"
                >
                  <feather-icon
                    icon="EyeIcon"
                    class="mr-50"
                  />
                  <span>View</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('update', 'subnets')"
                  @click.prevent="toEdit(props.row.id)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="deleteRowEnds(props.row.id)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="deleteHandler(props.row.id)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Permanently delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="props.row.is_deleted && $can('delete', 'subnets')"
                  @click.prevent="recoverRow(props.row.id)"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    class="mr-50"
                  />
                  <span>Recover</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <span v-else-if="props.column.field === 'is_public'">
            <b-badge
              v-if="props.row.is_public"
              pill
              variant="success"
            >True</b-badge>
            <b-badge
              v-else
              pill
              variant="danger"
            >False</b-badge>
          </span>
          <span v-else-if="props.column.field === 'ip_used'">
            <b-progress
              v-b-tooltip.hover
              :value="props.row.ip_used"
              :max="props.row.ip_total"
              style="min-width:90px; width:100%"
              show-progress
              animated
              :title="props.row.ip_used + ' of ' + props.row.ip_total"
            />
          </span>
        </template>
        <!-- pagination -->
        <template
          slot="pagination-bottom"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">
                Showing 1 to
              </span>
              <b-form-select
                v-model="perPage"
                :options="pageSizeOptions"
                class="mx-1"
                @change="perPageChanged"
              />
              <span class="text-nowrap"> of {{ pagination.total }} root entries.</span>
            </div>
            <div>
              <b-pagination
                v-if="pagination.last_page !== 1"
                :value="page"
                :total-rows="pagination.total"
                :per-page="perPage"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="changePage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card-body>
    <b-modal
      id="modalSoftDelete"
      ref="modalSoftDelete"
      :title="deleteErrorPopUpInfo.title"
      centered
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
    >
      <p v-html="deleteErrorPopUpInfo.content" />
    </b-modal>
    <b-modal
      id="addressesModal"
      ref="addressesModal"
      :title="addressesModalInfo.title"
      centered
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      size="lg"
    >
      <b-row>
        <b-col
          cols="12"
          class="mb-2"
        >
          <b-form-group
            label="Search"
            label-class="label-class"
          >
            <b-form-input
              v-model="addressesSearch"
              placeholder="Start entering an address or a site name..."
              @input="searchRowsModal"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="addressesSearchValues.length">
        <b-row
          v-for="(address, index) in addressesSearchValues"
          :key="index"
          class="table-colors"
          :class="index % 2 === 0 ? 'grey' : ''"
        >
          <b-col
            cols="1"
          >
            <span>{{ index + 1 }})</span>
          </b-col>
          <b-col

            cols="2"
          >
            <b-form-group
              label="Address"
              label-class="label-class"
            >
              <p>{{ address.address }}</p>
            </b-form-group>
          </b-col>
          <b-col
            cols="3"
          >
            <b-form-group
              label="Site"
              label-class="label-class"
            >
              <router-link
                v-if="address.site"
                :to="`/site/${address.site.id}/hardware/index`"
              >
                {{ address.site.name }}
              </router-link>
              <p v-else>
                -
              </p>
            </b-form-group>
          </b-col>
          <b-col
            cols="3"
          >
            <b-form-group
              label="Hardware"
              label-class="label-class"
            >
              <router-link
                v-if="address.hardware"
                :to="`/hardware/update/${address.hardware.id}`"
              >
                {{ address.hardware.name }}
              </router-link>
              <p v-else>
                -
              </p>
            </b-form-group>
          </b-col>
          <b-col

            cols="3"
          >
            <b-form-group
              label="Licence"
              label-class="label-class"
            >
              <router-link
                v-if="address.licence"
                :to="`/licence/update/${address.licence.id}`"
              >
                {{ address.licence.number }}
              </router-link>
              <p v-else>
                -
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row
        v-else
      >
        <b-col
          cols="12"
          class="text-center"
        >
          <p>No addresses found</p>
        </b-col>
      </b-row>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCardBody,
  BPagination,
  BButton,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormSelect,
  BModal,
  BProgress,
  VBTooltip,
  BSpinner,
  BFormCheckbox,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import { mapActions, mapState, mapMutations } from 'vuex'
import IndexPagesMixin from '@/mixins/IndexPages.vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TableMobile from '@/components/TableMobile.vue'
import { debounce } from '@/utils/utils'
import axiosIns from '../../axios-resolver'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormCheckbox,
    TableMobile,
    BCardCode,
    BCardBody,
    BButton,
    BPagination,
    BRow,
    BCol,
    BModal,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BProgress,
    BSpinner,
    VueGoodTable,
    BFormInput,
    BBadge,
  },
  mixins: [
    IndexPagesMixin,
  ],
  data() {
    return {
      isLoading: true,
      uppdateRouteName: 'ipam-update-ipv4',

      deleteErrorPopUpInfo: {},
      windowWidth: window.innerWidth,
      addressesModalInfo: {
        title: '',
        content: '',
      },

      addressesSearch: '',
      addressesSearchValues: [],

      fields: [
        {
          field: 'address',
          label: 'IP Network',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'IP Network',
            filterValue: '',
          },
        },
        {
          field: 'prefix',
          label: 'Prefix',
          filterOptions: {
            enabled: true,
            placeholder: 'Prefix',
            filterValue: '',
          },
          sortable: false,
        },
        {
          field: 'range',
          sortable: false,
          label: 'Range',
          filterOptions: {
            enabled: true,
            placeholder: 'Range',
            filterValue: '',
          },
        },
        { field: 'ip_used', label: 'Usage', sortable: false },
        { field: 'ip_total', label: '', hidden: true },
        {
          field: 'name',
          label: 'Name',
          filterOptions: {
            enabled: true,
            placeholder: 'Name',
            filterValue: '',
          },
        },
        {
          field: 'comment',
          label: 'Comment',
          filterOptions: {
            enabled: true,
            placeholder: 'Comment',
            filterValue: '',
          },
        },
        {
          field: 'is_public',
          label: 'Is Public',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter',
            filterValue: '',
          },
        },
        {
          field: 'company.name',
          sortable: false,
          label: 'NAS Owner',
          filterOptions: {
            enabled: true,
            placeholder: 'NAS Owner',
            filterValue: '',
          },
        },
        {
          field: 'type.name',
          sortable: false,
          label: 'Network Type',
          filterOptions: {
            enabled: true,
            placeholder: 'Network Type',
            filterValue: '',
          },
        },
        {
          field: 'category.name',
          label: 'Network Category',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Network Category',
            filterValue: '',
          },
        },
        {
          field: 'usage_type.name',
          sortable: false,
          label: 'Usage Type',
          filterOptions: {
            enabled: true,
            placeholder: 'Usage Type',
            filterValue: '',
          },
        },
        {
          field: 'action',
          label: 'Action',
          sortable: false,
          thClass: 'action-th-width',
          hidden: !this.$can('update', 'subnets') && !this.$can('delete', 'subnets'),
        },
      ],
    }
  },
  computed: {
    ...mapState('ipamIpv4', {
      items: 'items',
      pagination: 'pagination',
      searchFields: 'searchFields',
      orderBy: 'orderBy',
      sortedBy: 'sortedBy',
    }),
  },
  watch: {
    items() {
      const isPublicOptions = [
        { value: true, text: 'True' },
        { value: false, text: 'False' },
      ]

      this.fields = this.fields.map(item => {
        if (item.field === 'is_public') {
          // eslint-disable-next-line no-param-reassign
          item = { ...item, filterOptions: { ...item.filterOptions, filterDropdownItems: [...isPublicOptions] } }
        }
        return item
      })
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions('ipamIpv4', {
      fetchItems: 'getItems',
      deleteRecord: 'deleteItem',
      setSearchFields: 'setSearchFields',
      setOrderBy: 'setOrderBy',
      setSortedBy: 'setSortedBy',
      recoverRecord: 'recoverItem',
    }),
    searchRowsModal: debounce(function (value) {
      this.addressesSearchValues = this.addressesModalInfo.content.filter(item => item.address.includes(value) || (item.site && item.site.name.toLowerCase().includes(value.toLowerCase())))
    }, 1500),
    onResize() {
      this.isLoading = true
      this.windowWidth = window.innerWidth
      this.$nextTick(() => {
        this.isLoading = false
      })
    },
    ...mapMutations('ipamIpv4', ['RESET_STATE']),
    async deleteHandler(id) {
      const errorRes = await this.deleteRow(id)
      this.deleteErrorPopUpInfo = errorRes
    },
    rowStyleClassFn(row) {
      return row.is_deleted ? 'deleted-class' : ''
    },
    async getIPv4Address(subnetId, name) {
      this.addressesSearch = ''
      try {
        const { data } = await axiosIns.get(`/network/subnet/${subnetId}/addresses`)
        if (!data.data.ips) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'No addresses found',
              icon: 'BellIcon',
              variant: 'warning',
            },
          })
          return
        }
        this.addressesModalInfo = {
          title: `Used Addresses in ${name}`,
          content: data.data.ips,
        }
        this.addressesSearchValues = data.data.ips
        this.$refs.addressesModal.show()
      } catch (error) {
        console.log(error)
      }
    },
    async deleteRowEnds(id) {
      try {
        await this.deleteRecord({ id, type: 'end' })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted!',
            icon: 'BellIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        const { status } = error.response

        if (!status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Server error',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .vgt-table{
    th{
      vertical-align: middle !important;
      padding: 0.75em !important;
    }
    .vgt-row-header{
      background-color: rgb(254 212 0 / 18%) !important;
      font-size: 14px !important;
      font-weight: 400;
      border-bottom: 1px solid #ebe9f1 !important;
    }
  }
  .dark-layout{
    .vgt-row-header{
      background-color: rgba(11, 15, 28, 0.18) !important;
      border-bottom: 1px solid #3b4253 !important;
    }
  }
  .progress-bar {
    font-size: 0px;
  }
  .subnet-table {
    .deleted-class {
      .vgt-checkbox-col {
        background-color: rgba(255, 0, 0, 0.185) !important;
        input {
          display: none;
        }
      }
      .vgt-left-align {
        background-color: rgba(255, 0, 0, 0.185) !important;
      }
    }
  }
</style>
